import { TemplateElement, html, defineElement } from '@webtides/element-js';

class ProductSizes extends TemplateElement {
    constructor() {
        super({ shadowRender: false });
    }

    properties() {
        return {
            sizes: [],
        };
    }

    get disableNotAvailableVariants() {
        return window.siteConfig().disableNotAvailableVariants ?? false;
    }

    get sizeMap() {
        return this.sizes && this.sizes.length > 0 ? this.sizes : [{ enabled: false, value: html`&nbsp;` }];
    }

    template() {
        return html`
            ${this.sizeMap.map(size => {
                const enabled = !this.disableNotAvailableVariants || size.enabled;

                const sizeText = size.value ? size.value : size;
                const color = !enabled ? 'text-grey-300' : '';

                return html` <div class="size p-1 px-2 ${color}" data-enabled="${enabled}">${sizeText}</div> `;
            })}
        `;
    }
}

defineElement('product-sizes', ProductSizes);
